import React from 'react'

function Slider() {
  return (
    <>
    <div className="section slider-section">
          {/*  Slider Shape Start **/}
          <div className="slider-shape">
            <img
              className="shape-1 animation-round"
              src="assets/images/shape/shape-8.png"
              alt="Shape"
            />
          </div>
          {/*  Slider Shape End **/}

          <div className="container">
            {/*  Slider Content Start **/}
            <div className="slider-content">
              <h4 className="sub-title">Start your favourite course</h4>
              <h2 className="main-title">
              It's time to amplify you{" "}
                <span>career in IT.</span>
              </h2>
              <p>
              Now learn from anywhere. Whether you're beginner or an intermediate professional, this ultimate course will help you to reach your goal faster, and manage your email system with more confidence.
              </p>
              <a className="btn btn-primary btn-hover-dark" href="/#">
                Start A Course
              </a>
            </div>
            {/*  Slider Content End **/}
          </div>

          {/*  Slider Courses Box Start **/}
          <div className="slider-courses-box">
            <img className="shape-1 animation-left" src="assets/images/shape/shape-5.png" alt="Shape"/>

            <div className="box-content">
              <div className="box-wrapper">
                <i className="flaticon-open-book"></i>
                <span className="count">15+</span>
                <p>courses</p>
              </div>
            </div>

            <img
              className="shape-2"
              src="assets/images/shape/shape-6.png"
              alt="Shape"
            />
          </div>
          {/*  Slider Courses Box End **/}

          {/*  Slider Rating Box Start **/}
          <div className="slider-rating-box">
            <div className="box-rating">
              <div className="box-wrapper">
                <span className="count">
                  4.8 <i className="flaticon-star"></i>
                </span>
                <p>Rating (86K)</p>
              </div>
            </div>

            <img
              className="shape animation-up"
              src="assets/images/shape/shape-7.png"
              alt="Shape"
            />
          </div>
          {/*  Slider Rating Box End **/}

          {/*  Slider Images Start **/}
          <div className="slider-images">
            <div className="images">
              <img src="assets/images/slider/techijack_it_man1.webp" alt="Techijack Course" />
            </div>
          </div>
          {/*  Slider Images End **/}

          {/*  Slider Video Start **/}
          <div className="slider-video">
            <img
              className="shape-1"
              src="assets/images/shape/shape-9.png"
              alt="Shape"
            />

            <div className="video-play">
              <img src="assets/images/shape/shape-10.png" alt="Shape" />
              <a
                href="https://www.youtube.com/watch?v=BRvyWfuxGuU"
                className="play video-popup"
              >
                <i className="flaticon-play"></i>
              </a>
            </div>
          </div>
          {/*  Slider Video End **/}
        </div>
    </>
  );
}

export default Slider;